import React from 'react'
import styled from 'styled-components'
import { Button, Chip, Box } from '@allied-solutions/affinity'
import {
  getRequirementChipCount,
  getRequirementChipVariant,
} from '../../hooks/useGetCoverageRequirements'

const StyledButton = styled(Button)`
  justify-content: flex-start;
  border-radius: ${props => props.theme.radii[1]};

  &:hover:not(:disabled) {
    color: ${props => props.theme.colors.blue800};

    & .iconSize-md svg {
      color: ${props => props.theme.colors.blue800};
    }
  }

  ${props =>
    props.$isActive &&
    `
    color: ${props.theme.colors.blue800};
    background-color: ${props.theme.colors.background.grayMuted};

    & .iconSize-md svg {
      color: ${props.theme.colors.blue800};
    }
  `}
`

export const DashboardTileNavListItem = ({
  title,
  id,
  icon,
  isActive,
  setActiveTab,
  coverageRequirementsData,
}) => {
  const chipCount = getRequirementChipCount(coverageRequirementsData)
  const chipVariant = getRequirementChipVariant(coverageRequirementsData)

  return (
    <StyledButton
      ghost
      variant="gray"
      icon={icon}
      $isActive={isActive}
      onClick={() => setActiveTab(id)}
    >
      <Box display="flex" alignItems="center" gap="md">
        {title}
        {chipCount > 0 && (
          <Chip label={chipCount} rounded variant={chipVariant} />
        )}
      </Box>
    </StyledButton>
  )
}
